
<template>
  <Content>
    <div class="cart-page py-4">
      <!-- عنوان صفحه -->
      <div class="d-flex align-items-center justify-content-between mb-4">
        <h4 class="fw-bold text-teal m-0 d-flex align-items-center gap-2">
          <i class="bi bi-bag-heart-fill fs-3 text-pink"></i>
          {{ currentLang.title }}
        </h4>
      </div>

      <div
        v-if="validationErrors.length > 0"
        class="alert alert-danger rounded-3 p-3 mb-3 small d-flex flex-column gap-1"
      >
        <div class="d-flex align-items-center gap-2 fw-bold mb-1">
          <i class="bi bi-exclamation-triangle-fill text-danger fs-6"></i>
          <span>لطفاً موارد زیر را تکمیل کنید:</span>
        </div>
        <ul class="m-0 ps-3">
          <li v-for="(err, index) in validationErrors" :key="index">
            {{ err }}
          </li>
        </ul>
      </div>

      <!-- لودینگ -->
      <div v-if="loading" class="text-center py-5">
        <div class="spinner-border text-teal" role="status">
          <span class="visually-hidden">Loading...</span>
        </div>
      </div>

      <div v-else class="row g-4">
        <div class="col-12 col-lg-8">
          <div class="cart-items-list">
            <!--/address -->

            <!-- بخش مدیریت آدرس‌ها -->
            <div class="address-section mb-4">
              <div
                class="address-header d-flex align-items-center justify-content-between mb-3"
              >
                <h5
                  class="fw-bold text-dark m-0 d-flex align-items-center gap-2"
                >
                  <i class="bi bi-geo-alt-fill text-teal"></i>
                  {{ currentLang.selectAddress || "انتخاب آدرس" }}
                </h5>
                <button
                  @click="openAddModal"
                  class="btn btn-sm btn-teal-kids rounded-pill px-3 shadow-sm"
                >
                  <i class="bi bi-plus-lg"></i>
                  {{ currentLang.addNewAddress || "آدرس جدید" }}
                </button>
              </div>

              <!-- کانتینر اصلی آدرس‌ها -->
              <div class="address-container p-3 rounded-4 border">
                <div
                  v-if="addresses.length === 0"
                  class="text-center py-4 text-muted"
                >
                  <i class="bi bi-geo-alt fs-1 d-block mb-2 opacity-25"></i>
                  {{ currentLang.noAddressFound || "هیچ آدرسی یافت نشد" }}
                </div>

                <div v-else class="address-list d-flex flex-column gap-3">
                  <div
                    v-for="addr in addresses"
                    :key="addr.id"
                    class="address-item-row p-3 rounded-3 border position-relative"
                    :class="{ 'is-selected': selectedAddressId === addr.id }"
                    @click="selectedAddressId = addr.id"
                  >
                    <!-- نشانگر انتخاب -->
                    <div
                      v-if="selectedAddressId === addr.id"
                      class="selection-badge"
                    >
                      <i class="bi bi-check-circle-fill"></i>
                    </div>

                    <div class="row align-items-center">
                      <!-- بخش اطلاعات اصلی -->
                      <div class="col-12 col-md-8">
                        <div class="d-flex align-items-center gap-2 mb-1">
                          <span class="fw-bold text-dark">{{
                            addr.title
                          }}</span>
                          <span class="text-muted small"
                            >| {{ addr.province.name }},
                            {{ addr.city.name }}</span
                          >
                        </div>
                        <p class="mb-1 text-secondary small text-truncate-2">
                          {{ addr.address }} {{ addr.details }}
                        </p>
                        <div class="d-flex gap-3 mt-2">
                          <span class="text-muted extra-small"
                            ><i class="bi bi-telephone me-1"></i
                            >{{ addr.phone }}</span
                          >
                          <span class="text-muted extra-small"
                            ><i class="bi bi-envelope me-1"></i
                            >{{ addr.postal_code }}</span
                          >
                        </div>
                      </div>

                      <!-- بخش عملیات (ویرایش/حذف) -->
                      <div class="col-12 col-md-4 text-md-end mt-3 mt-md-0">
                        <div
                          class="action-buttons d-flex justify-content-md-end gap-2"
                        >
                          <button
                            v-if="selectedAddress"
                            @click="openEditModal(selectedAddress)"
                            class="btn btn-light btn-sm rounded-pill px-3 border"
                          >
                            <i class="bi bi-pencil me-1"></i> ویرایش
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <!-- روش پرداخت  -->

            <div class="address-section">
              <h5 class="fw-bold text-dark m-0 d-flex align-items-center gap-2">
                <i class="bi bi-credit-card-fill text-teal"></i>
                انتخاب روش پرداخت
              </h5>

              <div class="row g-3 mt-2">
                <div
                  v-for="method in paymentMethods"
                  :key="method.id"
                  class="col-12 col-md-6"
                >
                  <div
                    class="payment-option b-w p-3 border rounded d-flex align-items-center"
                    :class="{ active: selectedPaymentId === method.id }"
                    @click="
                      selectedPaymentId = method.id;
                      syncOrderCheck();
                    "
                  >
                    <i class="bi bi-credit-card me-2 fs-4"></i>
                    <span class="fw-bold">{{ method.name_fa }}</span>
                  </div>
                </div>
              </div>
            </div>

            <!-- روش ارسال  -->

            <div class="address-section">
              <h5 class="fw-bold text-dark m-0 d-flex align-items-center gap-2">
                <i class="bi bi-truck text-teal"></i>
                انتخاب روش ارسال
              </h5>

              <div class="row g-3 mt-2">
                <div
                  v-for="method in shippingMethods"
                  :key="method.id"
                  class="col-12 col-md-6"
                >
                  <div
                    class="payment-option p-3 border rounded d-flex align-items-center"
                    :class="{ active: selectedShippingId === method.id }"
                    @click="
                      selectedShippingId = method.id;
                      syncOrderCheck();
                    "
                  >
                    <i class="bi bi-credit-card me-2 fs-4"></i>
                    <span class="fw-bold">{{ method.name_fa }}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- خلاصه سفارش -->
        <div class="col-12 col-lg-4">
          <div
            class="summary-card card border-0 shadow-sm rounded-4 sticky-top"
          >
            <div class="card-body p-4">
              <h5
                class="fw-bold text-dark mb-4 pb-2 border-bottom d-flex align-items-center gap-2"
              >
                <i class="bi bi-receipt text-teal"></i>
                {{ currentLang.summaryTitle }}
              </h5>

              <!-- مبلغ کالاها -->
              <div class="summary-row">
                <span>{{ currentLang.subtotal }}</span>

                <strong>
                  {{ formatPrice(orderSummary.subtotal) }}
                </strong>
              </div>

              <!-- مالیات -->
              <div class="summary-row">
                <span>{{ currentLang.tax }}</span>

                <strong>
                  {{ formatPrice(orderSummary.tax) }}
                </strong>
              </div>

              <!-- هزینه ارسال -->
              <div class="summary-row">
                <span>{{ currentLang.shippingCost }}</span>

                <span
                  v-if="Number(orderSummary.shipping_cost || 0) === 0"
                  class="badge bg-success-subtle text-success rounded-pill px-3 py-1"
                >
                  {{ currentLang.freeShipping }}
                </span>

                <strong v-else>
                  {{ formatPrice(orderSummary.shipping_cost) }}
                </strong>
              </div>

              <!-- تخفیف -->
              <div
                v-if="Number(orderSummary.discount || 0) > 0"
                class="summary-row text-danger"
              >
                <span>{{ currentLang.discount }}</span>

                <strong> - {{ formatPrice(orderSummary.discount) }} </strong>
              </div>

              <!-- تخفیف روش پرداخت -->
              <div
                v-if="Number(orderSummary.discount_payment_method || 0) > 0"
                class="summary-row text-danger"
              >
                <span>
                  {{ currentLang.discountPaymentMethod }}
                </span>

                <strong>
                  -
                  {{ formatPrice(orderSummary.discount_payment_method) }}
                </strong>
              </div>

              <!-- مجموع تخفیف -->
              <div
                v-if="Number(orderSummary.total_discount || 0) > 0"
                class="summary-row text-danger fw-bold"
              >
                <span>{{ currentLang.totalDiscount }}</span>

                <strong>
                  - {{ formatPrice(orderSummary.total_discount) }}
                </strong>
              </div>

              <hr class="my-3 opacity-25" />

              <!-- مبلغ قابل پرداخت -->
              <div class="summary-total">
                <span>{{ currentLang.payableAmount }}</span>

                <strong>
                  {{ formatPrice(orderSummary.total_price) }}
                </strong>
              </div>

              <!-- نمایش خطاهای ولیدیشن 422 -->
              <div
                v-if="validationErrors.length > 0"
                class="alert alert-danger rounded-3 p-3 mb-3 small d-flex flex-column gap-1"
              >
                <div class="d-flex align-items-center gap-2 fw-bold mb-1">
                  <i
                    class="bi bi-exclamation-triangle-fill text-danger fs-6"
                  ></i>
                  <span>لطفاً موارد زیر را تکمیل کنید:</span>
                </div>
                <ul class="m-0 ps-3">
                  <li v-for="(err, index) in validationErrors" :key="index">
                    {{ err }}
                  </li>
                </ul>
              </div>
              <!-- جایگزین دکمه قبلی در خلاصه سفارش -->
              <button
                type="button"
                class="btn btn-teal-kids w-100 py-3 rounded-pill fw-bold shadow-sm d-flex align-items-center justify-content-center gap-2"
                @click="handleProceedToCheckout"
              >
                <span>{{ currentLang.proceedToCheckout }}</span>

                <i
                  :class="
                    lang === 'fa' ? 'bi bi-arrow-left' : 'bi bi-arrow-right'
                  "
                ></i>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>

    <footerAdmin></footerAdmin>
  </Content>
  <!-- در template فایل Cart.vue -->
  <AddressModal
    :is-open="isModalOpen"
    :mode="modalMode"
    :initial-address="editingAddress"
    @close="closeModal"
    @saved="handleAddressSaved"
  />
</template>




<script setup>
import Content from "@/components/AdminContent.vue";
import footerAdmin from "@/components/AdminFooter.vue";
import { ref, onMounted, computed } from "vue";
import api from "@/plugins/axios";
import { useCart } from "@/stores/cart";
import { lang } from "@/plugins/lang";

import { useRouter } from "vue-router";
import AddressModal from "@/components/AddressModal.vue";
const validationErrors = ref([]);
import enText from "@/locales/en/shipping";
import faText from "@/locales/fa/shipping";

const { items: localItems, clearCart } = useCart();

const translations = { en: enText, fa: faText };
const currentLang = computed(() => translations[lang.value]);

const loading = ref(false);

const router = useRouter();
const paymentMethods = ref([]);
const selectedPaymentId = ref(null);

const shippingMethods = ref([]);
const selectedShippingId = ref(null);

const userInfo = ref(null);

try {
  const savedUser = localStorage.getItem("user_info");
  userInfo.value = savedUser ? JSON.parse(savedUser) : null;
} catch (error) {
  localStorage.removeItem("user_info");
}

// هدایت یا باز کردن مدال بر اساس وضعیت لاگین
const handleProceedToCheckout = () => {
  saveOrder();
};

/*
|--------------------------------------------------------------------------
| داده‌های سبد — همه از ریسپانسیو ordercheck خوانده می‌شوند
|--------------------------------------------------------------------------
*/
const serverItems = ref([]);
const orderSummary = ref({
  subtotal: 0,
  tax: 0,
  shipping_cost: 0,
  discount: 0,
  discount_payment_method: 0,
  total_discount: 0,
  total_price: 0,
  items: [],
});

const syncOrderCheck = async () => {
  if (!localItems.value || localItems.value.length === 0) {
    serverItems.value = [];
    orderSummary.value = {
      subtotal: 0,
      tax: 0,
      shipping_cost: 0,
      discount: 0,
      discount_payment_method: 0,
      total_discount: 0,
      total_price: 0,
      items: [],
    };
    return;
  }

  loading.value = true;
  try {
    const response = await api.post("general/order/check", {
      items: localItems.value.map((item) => ({
        product_id: item.product_id || item.id,
        quantity: item.quantity,
      })),
      ...(selectedPaymentId.value !== null && {
        payment_method_id: selectedPaymentId.value,
      }),
      ...(selectedShippingId.value !== null && {
        shipping_method_id: selectedShippingId.value,
      }),

      ...(selectedAddressId.value !== null && {
        addressـid: selectedAddressId.value,
      }),
    });

    const data = response.data?.data || response.data;

    if (data) {
      serverItems.value = data.items || [];
      // eslint-disable-next-line
      const { items, ...summary } = data;
      orderSummary.value = { ...orderSummary.value, ...summary, items: [] };
    }
  } catch (error) {
    console.error("Ordercheck sync error:", error);
  } finally {
    loading.value = false;
  }
};

// eslint-disable-next-line
const saveOrder = async () => {
  validationErrors.value = []; // پاک کردن خطاهای قبلی قبل از شروع
  if (!localItems.value || localItems.value.length === 0) {
    serverItems.value = [];
    orderSummary.value = {
      subtotal: 0,
      tax: 0,
      shipping_cost: 0,
      discount: 0,
      discount_payment_method: 0,
      total_discount: 0,
      total_price: 0,
      items: [],
    };
    return;
  }

  loading.value = true;
  try {
    const response = await api.post("client/orders", {
      items: localItems.value.map((item) => ({
        product_id: item.product_id || item.id,
        quantity: item.quantity,
      })),
      ...(selectedPaymentId.value !== null && {
        payment_method_id: selectedPaymentId.value,
      }),
      ...(selectedShippingId.value !== null && {
        shipping_method_id: selectedShippingId.value,
      }),
      ...(selectedAddressId.value !== null && {
        address_id: selectedAddressId.value,
      }),
    });

    const data = response.data?.data || response.data;

    if (data) {
      serverItems.value = data.items || [];
      // eslint-disable-next-line
      const { items, ...summary } = data;
      orderSummary.value = { ...orderSummary.value, ...summary, items: [] };
      clearCart();
      router.push('/fa/dashboard/orders');
    }
  } catch (error) {
    if (error.response && error.response.status === 422) {
      const { errors, message } = error.response.data;
      if (errors) {
        // فلت کردن آرایه خطاهای دریافتی
        validationErrors.value = Object.values(errors).flat();
      } else if (message) {
        validationErrors.value = [message];
      }
    } else {
      console.error("Order save error:", error);
    }
  } finally {
    loading.value = false;
  }
};

/*
|--------------------------------------------------------------------------
| توابع کمکی
|--------------------------------------------------------------------------
*/
const formatPrice = (price) => {
  if (price === null || price === undefined)
    return `۰ ${currentLang.value?.toman || "تومان"}`;

  return `${Number(price).toLocaleString(
    lang.value === "fa" ? "fa-IR" : "en-US"
  )} ${currentLang.value?.toman || "تومان"}`;
};

// اضافه کردن به متغیرهای اولیه
const addresses = ref([]);
const selectedAddress = ref(null); // آدرس انتخاب شده فعلی
const selectedAddressId = ref(null);
const isModalOpen = ref(false);
const modalMode = ref("create"); // 'create' or 'edit'
const editingAddress = ref(null); // آدرسی که برای ویرایش به مدال ارسال می‌شود
const isAddressSelected = ref(false);

// دریافت لیست آدرس‌ها
const fetchAddresses = async () => {
  try {
    const response = await api.get("client/address");
    addresses.value = response.data.data;
    if (addresses.value.length > 0) {
      selectedAddress.value = addresses.value[0]; // انتخاب اولین آدرس به صورت پیش‌فرض
      isAddressSelected.value = true;
    }
  } catch (error) {
    console.error("Error fetching addresses:", error);
  }
};

const fetchPaymentMethods = async () => {
  try {
    const response = await api.get("client/payment-methods");
    paymentMethods.value = response.data.data;
  } catch (error) {
    console.error("Error loading payment methods:", error);
  }
};

const fetchShippingMethods = async () => {
  try {
    const response = await api.get("client/shipping-methods");
    shippingMethods.value = response.data.data;
  } catch (error) {
    console.error("Error loading shipping methods:", error);
  }
};

// const selectAddress = (address) => {
//   selectedAddress.value = address;
//   isAddressSelected.value = true;
//   // در اینجا می‌توانیم آدرس انتخاب شده را در store یا state گلوبال ذخیره کنیم
// };

// در script کامپوننت Cart.vue
const handleAddressSaved = async () => {
  await fetchAddresses(); // به‌روزرسانی لیست آدرس‌ها پس از ذخیره یا ویرایش
};

const openAddModal = () => {
  modalMode.value = "create";
  editingAddress.value = null; // اطمینان از اینکه برای حالت ایجاد، آدرسی ارسال نمی‌شود
  isModalOpen.value = true;
};

const openEditModal = (address) => {
  modalMode.value = "edit";
  editingAddress.value = { ...address }; // ارسال یک کپی از آدرس برای جلوگیری از تغییر مستقیم
  isModalOpen.value = true;
};

const closeModal = () => {
  isModalOpen.value = false;
  editingAddress.value = null; // پاک کردن داده‌های مربوط به ویرایش
};

// فراخوانی در onMounted
onMounted(() => {
  syncOrderCheck();
  fetchAddresses();
  fetchPaymentMethods();
  fetchShippingMethods();
});
</script>

<style scoped>
.payment-option {
  cursor: pointer;
  transition: all 0.3s ease;
  border: 2px solid #dee2e6;
  background-color: #ffffff !important; /* یک پس‌زمینه بسیار ملایم برای کل سکشن */
}

.payment-option:hover {
  background-color: #f8f9fa;
  border-color: #ced4da;
}

.payment-option.active {
  border-color: #0d9488 !important;
  background-color: #f0fdfa;
  box-shadow: 0 4px 12px rgba(13, 148, 136, 0.1);
}

/* استایل بخش کانتینر آدرس */
.address-section {
  background-color: #f8fafc; /* یک پس‌زمینه بسیار ملایم برای کل سکشن */
  padding: 20px;
  border-radius: 1.5rem;
  border: 1px dashed #cbd5e1; /* مرز خط‌چین برای تمایز بخش آدرس */
}

.address-container {
  background: #ffffff;
}

.address-item-row {
  cursor: pointer;
  transition: all 0.2s ease;
  border-color: #e2e8f0 !important;
}

.address-item-row:hover {
  border-color: #94a3b8 !important;
  transform: translateY(-2px);
}

/* حالت انتخاب شده */
.address-item-row.is-selected {
  border-color: #0d9488 !important;
  background-color: #f0fdfa;
  box-shadow: 0 4px 12px rgba(13, 148, 136, 0.1);
}

/* نشانگر تیک انتخاب */
.selection-badge {
  position: absolute;
  top: -10px;
  right: -10px;
  background: #0d9488;
  color: white;
  border-radius: 50%;
  width: 24px;
  height: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 12px;
  z-index: 2;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

/* متن‌های کوچک */
.extra-small {
  font-size: 0.75rem;
}

.text-truncate-2 {
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
}

/* هماهنگی با دکمه‌های شما */
.address-header h5 {
  font-size: 1.1rem;
}

/* پالت رنگی و متغیرها */
:root {
  --teal-primary: #0d9488;
  --teal-hover: #0f766e;
  --pink-accent: #ec4899;
}

.text-teal {
  color: #0d9488 !important;
}

.text-pink {
  color: #ec4899 !important;
}

.btn-teal-kids {
  background-color: #0d9488;
  border-color: #0d9488;
  color: #fff;
  transition: all 0.2s ease-in-out;
}

.btn-teal-kids:hover {
  background-color: #0f766e;
  border-color: #0f766e;
  color: #fff;
}

/* صفحه و وضعیت خالی */
.cart-page {
  margin: 10px;
  min-height: 60vh;
}

.empty-icon-wrapper i {
  font-size: 4.5rem;
}

/* کارت‌های محصول */
.cart-items-list {
  display: flex;
  flex-direction: column;
  gap: 1rem;
}

.product-cart-card {
  background: #ffffff;
  border-radius: 1rem;
  padding: 1.25rem;
  border: 1px solid #f1f5f9;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04);
  display: flex;
  flex-direction: column;
  gap: 1rem;
  transition: box-shadow 0.2s ease;
}

.product-cart-card:hover {
  box-shadow: 0 4px 14px rgba(0, 0, 0, 0.07);
}

/* بخش اصلی کارت: عکس و اطلاعات */
.product-card-main {
  display: flex;
  align-items: flex-start;
  gap: 1rem;
}

.product-card-image {
  width: 90px;
  height: 90px;
  min-width: 90px;
  border-radius: 0.75rem;
  overflow: hidden;
  background-color: #f8fafc;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 1px solid #e2e8f0;
}

.product-card-image img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.product-card-image-placeholder i {
  font-size: 2rem;
  color: #cbd5e1;
}

.product-card-content {
  flex: 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: 0.35rem;
}

.product-card-title-row {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 0.75rem;
}

.product-card-title {
  font-weight: 600;
  color: #1e293b;
  text-decoration: none;
  font-size: 1rem;
  line-height: 1.4;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
}

.product-card-title:hover {
  color: #0d9488;
}

.product-card-delete {
  background: none;
  border: none;
  color: #94a3b8;
  padding: 0.25rem;
  line-height: 1;
  border-radius: 0.5rem;
  cursor: pointer;
  transition: color 0.15s ease, background 0.15s ease;
}

.product-card-delete:hover {
  color: #ef4444;
  background-color: #fee2e2;
}

.product-card-category {
  font-size: 0.82rem;
  color: #64748b;
}

.product-card-price {
  font-size: 0.88rem;
  color: #475569;
  display: flex;
  align-items: center;
  gap: 0.35rem;
}

.product-card-price strong {
  color: #0f172a;
  font-size: 0.95rem;
}

/* بخش جزئیات محصول (گرید ستون‌ها) */
.product-card-details {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(130px, 1fr));
  gap: 0.75rem;
  background: #f8fafc;
  padding: 0.75rem 1rem;
  border-radius: 0.75rem;
}

.product-card-detail {
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
  font-size: 0.85rem;
}

.product-card-detail-label {
  color: #64748b;
  font-size: 0.78rem;
  display: flex;
  align-items: center;
  gap: 0.3rem;
}

/* کنترل تعداد */
.product-card-quantity {
  display: inline-flex;
  align-items: center;
  gap: 0.5rem;
  background: #fff;
  border: 1px solid #cbd5e1;
  border-radius: 9999px;
  padding: 0.15rem 0.4rem;
  width: fit-content;
}

.quantity-button {
  background: none;
  border: none;
  width: 26px;
  height: 26px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  color: #334155;
  transition: background 0.15s ease;
}

.quantity-button:hover:not(:disabled) {
  background-color: #e2e8f0;
}

.quantity-button:disabled {
  opacity: 0.35;
  cursor: not-allowed;
}

.quantity-value {
  min-width: 22px;
  text-align: center;
  font-weight: 600;
  font-size: 0.9rem;
}

/* جمع نهایی کارت تکی */
.product-card-total {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding-top: 0.5rem;
  border-top: 1px dashed #e2e8f0;
  font-size: 0.9rem;
  color: #475569;
}

.product-card-total strong {
  font-size: 1.1rem;
  color: #0d9488;
}

/* کارت فاکتور / خلاصه سفارش */
.summary-card {
  top: 1.5rem;
  background: #ffffff;
}

.summary-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 0.85rem;
  font-size: 0.92rem;
  color: #475569;
}

.summary-row strong {
  color: #1e293b;
}

.summary-total {
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: 1.05rem;
  font-weight: 700;
  color: #0f172a;
  margin-bottom: 1.25rem;
}

.summary-total strong {
  font-size: 1.25rem;
  color: #0d9488;
}

/* واکنش‌گرایی برای موبایل */
@media (max-width: 575.98px) {
  .product-cart-card {
    padding: 1rem;
  }

  .product-card-image {
    width: 75px;
    height: 75px;
    min-width: 75px;
  }

  .product-card-title {
    font-size: 0.92rem;
  }

  .product-card-details {
    grid-template-columns: 1fr 1fr;
    gap: 0.6rem 0.5rem;
    padding: 0.6rem 0.75rem;
  }

  .product-card-total strong {
    font-size: 1rem;
  }

  .summary-card .card-body {
    padding: 1.25rem;
  }
}
</style>
